;(() => {
    if (customElements.get("hoculus-variant-availability")) return;

    class HoculusVariantAvailability extends HTMLElement {
        productVariants = JSON.parse(JSON.parse(this.dataset.productVariants)?.variants ?? []);
        config = {
            forecast: JSON.parse(this.dataset.settings),
            placeholder: "[DATA]"
        }
        weekNumbers = this.config.forecast.workingDays.split(',').map(Number);
        holidays = this.config.forecast.holidays || [];
        variantPicker = document.querySelector("variant-picker");

        constructor() {
            super();

            this.config.forecast.availabilityMessage = JSON.parse(this.config.forecast.availabilityMessage);

            this.updateAvailability(this.config.forecast.daysTillAvailability);

            if (!this.variantPicker) return;

            this.variantPicker.addEventListener("on:variant:change", this.handleVariantChange.bind(this));
        }

        // Updates the visibility of the elements
        handleVariantChange(evt) {
            const v = this.productVariants.find(v => v[evt.detail.variant.id]);
            if (v) {
                const daysTillAvailability = v[evt.detail.variant.id];
                this.updateAvailability(daysTillAvailability);
                this.style.display = "block"
                document.querySelector(".hoculus-variant-immediately-available").style.display = "none";
            } else  {
                document.querySelector(".hoculus-variant-immediately-available").style.display = "block";
                this.style.display = "none"
            }
        }

        updateAvailability(days) {
            this.forecastDay = this.getAvailability(days);

            if (this.config.forecast.showTimeInWeeks) {
                this.innerHTML = `${this.config.forecast.availabilityMessage[this.forecastDay > 1 ? 'more' : 'one'].replace(this.config.placeholder, this.forecastDay)}`;
            } else {
                this.innerHTML = `${this.config.forecast.availabilityMessage.one.replace(this.config.placeholder, this.forecastDay)}`;
            }

        }

        getAvailability(days) {
            const addVariantAvailabilityDaysExcludingWeekends = (startDate, daysToAdd) => {
                let currentDate = new Date(startDate);
                let daysAdded = 0;
                
                while (daysAdded < daysToAdd) {
                    currentDate.setDate(currentDate.getDate() + 1);

                    // Check if the current day is in the working days set in the editor
                    if (this.weekNumbers.includes(currentDate.getDay())) daysAdded++;
                }
            
                return currentDate;
            }

            const todayDate = new Date();


            const baseDate = addVariantAvailabilityDaysExcludingWeekends(todayDate, days);

            // Check if in the time span between today and the availability date there are any holidays
            let holidaysToAdd = 0;
            for (const holiday of this.holidays) {
                const [d, m] = holiday.split("/");
                const h = `${todayDate.getFullYear()}-${m}-${d}`;
                const holidayDate = new Date(h);

                if (holidayDate <= baseDate && holidayDate >= todayDate && this.weekNumbers.includes(holidayDate.getDay())) holidaysToAdd++;
            }
            baseDate.setDate(baseDate.getDate() + holidaysToAdd);


            // If the final day is weekend, set the availability date to be the next Monday
            if (baseDate.getDay() === 6) baseDate.setDate(baseDate.getDate() + 2);
            else if (baseDate.getDay() === 0) baseDate.setDate(baseDate.getDate() + 1);

            const calculateWeeksBetween = (currentDate, futureDate) => {
                // Calculate the difference in time (milliseconds) between the two dates
                let differenceInTime = futureDate.getTime() - currentDate.getTime();
            
                // Convert the time difference from milliseconds to days
                let differenceInDays = differenceInTime / (1000 * 3600 * 24);
            
                // Convert days to weeks
                let differenceInWeeks = Math.ceil(differenceInDays / 7);
            
                return differenceInWeeks;
            }

            if (this.config.forecast.showTimeInWeeks) return calculateWeeksBetween(todayDate, baseDate);
            
            const locale = window.Shopify.locale
            const country = window.Shopify.country
            const locales = `${locale}-${country}`

            return baseDate.toLocaleDateString(locales, { weekday: "long", day: '2-digit', month: "long" });
        }
    }

    customElements.define('hoculus-variant-availability', HoculusVariantAvailability);
})();